import DashboardLayout from "../../layouts/DashboardLayout";
import ExpertConnect from "../../components/ExpertConnect/ExpertConnect";

export default function ChatPage() {
  return (
    <DashboardLayout>
      <ExpertConnect />
    </DashboardLayout>
  );
}
